import React from 'react';

export const TaskStatusBadge = ({ status }: { status: string }) => {
  const statusClasses: { [key: string]: string } = {
    open: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    'in_progress': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    resolved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    closed: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    deleting: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
  };
  const badgeClass = statusClasses[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${badgeClass}`}>
      {status.replace('_', ' ')}
    </span>
  );
};

export const TaskPriorityBadge = ({ priority }: { priority: string | number | null | undefined }) => {
  const p = typeof priority === 'number' ?
    (priority > 2 ? 'high' : priority > 1 ? 'medium' : 'low') :
    (priority?.toString().toLowerCase() || 'medium');
  const priorityClasses: { [key: string]: string } = {
    high: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    medium: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    low: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  };
  const badgeClass = priorityClasses[p] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${badgeClass}`}>
      {p}
    </span>
  );
};